import React from 'react';
import styles from './ShareView.module.scss';
import skeletonStyles from './ShareViewPlaceholder.module.scss';

export const ShareViewPlaceholder = () => {
  return (
    <div className={styles.shareViewSection}>
      <div className={styles.header}>
        <h3 className={styles.heading}>Add...</h3>
        <div className={styles.content}>
          <div className={skeletonStyles.heading}>
            <div className={skeletonStyles.headingText}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
          <div className={skeletonStyles.member}>
            <div className={skeletonStyles.memberAvatar}></div>
            <div className={skeletonStyles.memberName}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
